import React, { useRef, useEffect } from 'react';
import useBindToContext from 'hooks/useBindToContext';
import ReactQuill from 'react-quill';
import uuid from 'uuid/v1';
import { GOOGLE_FONTS } from 'lib/globals';
import 'react-quill/dist/quill.snow.css';
import classNames from 'lib/classNames';

const getColors = (value) => {
	const array = [];
	if (value === null || value === undefined) return [];
	if (typeof value === 'string' && new RegExp('^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$').test(value)) array.push(value);
	else if (typeof value === 'object') {
		Object.entries(value).forEach(([key, v]) => {
			array.push(getColors(value[key]));
		});
	}
	return array;
};

const RichEditor = ({
	BindToContext,
	value,
	onChange,
	specificValidation = null,
	getError = null,
	validation = null,
	disabled = false,
	onFocus = null,
	onBlur = null,
	placeholder = undefined,
	imageEmoji = false,
	rtl = false,
	debug = false,
}) => {
	const id = uuid();
	const editorRef = useRef({ current: null });
	const [BindedValue, BindedOnChange, _hasError, onRender] = useBindToContext(
		BindToContext,
		value,
		onChange,
		specificValidation,
		getError,
		validation,
		debug
	);
	const colors = BindToContext ? [...new Set(getColors(BindToContext[0].state).flat(Infinity))] : [];

	//useEffect(() => {
		//if (onRender?.length) onRender.forEach(fn => fn());
	//}, [onRender]);
	// useEffect(() => {
	// 	if (editorRef.current && rtl) {
	// 		const editor = editorRef.current.getEditor();
	// 		editor.format('direction', 'rtl');
	// 		editor.format('align', 'right');
	// 	}
	// }, [editorRef]);

	return (
		<ReactQuill
			id={id}
			className={classNames('bg-white', {
				'emoji-image': imageEmoji,
			})}
			ref={editorRef}
			theme="snow"
			disabled={disabled}
			value={BindedValue}
			placeholder={placeholder}
			onChange={(value) => BindedOnChange(value)}
			onFocus={() => {
				if (onFocus) onFocus();
			}}
			onBlur={() => {
				if (onBlur) {
					const editor = document.getElementById(id);
					const activeElement = document.activeElement;
					onBlur(editor, activeElement);
				}
			}}
			modules={{
				toolbar: [
					[{ size: ['small', false, 'large', 'huge'] }],
					['bold', 'italic', 'underline', 'strike'],
					// [
					// 	{
					// 		font: GOOGLE_FONTS.map(({ value }) => ({
					// 			value: value,
					// 		})),
					// 	},
					// ],
					[{ align: [] }],
					[{ color: colors }],
					['image', 'direction'],
					['link']
				],
			}}
		/>
	);
};

export default RichEditor;
